import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";
import { FaArrowLeft, FaBell } from "react-icons/fa";

const labelMap = {
  quote_request: "Nouvelle demande de devis",
  // Ajoute d'autres types ici si besoin
};

function renderValue(key, val) {
  if (
    key === "inventory" &&
    Array.isArray(val) &&
    val.length > 0 &&
    typeof val[0] === "object"
  ) {
    return (
      <div className="overflow-x-auto rounded-xl border border-base-200 mt-2">
        <table className="table table-sm">
          <thead className="bg-base-200 border-b border-base-200">
            <tr>
              <th className="text-base-content/50 text-[11px] font-semibold tracking-wider uppercase py-2">Objet</th>
              <th className="text-base-content/50 text-[11px] font-semibold tracking-wider uppercase py-2 text-right">Quantité</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-base-200">
            {val.map((item, idx) => (
              <tr key={idx} className="hover:bg-base-200/50 transition-colors">
                <td className="py-2 text-sm text-base-content">{item.name || item.label}</td>
                <td className="py-2 text-sm text-base-content/70 text-right">{item.qty || item.quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  if (Array.isArray(val)) {
    return (
      <ul className="list-disc list-inside ml-4 text-sm text-base-content/70 space-y-0.5">
        {val.map((item, idx) => (
          <li key={idx}>{String(item)}</li>
        ))}
      </ul>
    );
  }
  if (typeof val === "object" && val !== null) {
    return (
      <div className="ml-2 border-l-2 border-base-300 pl-3 text-sm text-base-content/60 space-y-0.5">
        {Object.entries(val).map(([k, v]) => (
          <div key={k}>
            <strong className="text-base-content/70">{k}:</strong>{" "}
            <span>{renderValue(k, v)}</span>
          </div>
        ))}
      </div>
    );
  }
  return <span className="text-base-content/70">{String(val)}</span>;
}

const NotificationDetail = () => {
  const { id } = useParams();
  const [notif, setNotif] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/notifications/${id}`)
      .then(res => setNotif(res.data))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="p-6 max-w-xl mx-auto">
      {/* Page Header */}
      <div className="flex items-center gap-3 mb-6">
        <button
          className="w-8 h-8 rounded-lg flex items-center justify-center text-base-content/40 hover:text-base-content hover:bg-base-300 transition-colors"
          onClick={() => navigate(-1)}
          title="Retour"
        >
          <FaArrowLeft className="w-4 h-4" />
        </button>
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0">
          <FaBell className="w-5 h-5" />
        </div>
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-base-content">
            Détail de la notification
          </h1>
          <p className="text-sm text-base-content/40 mt-0.5">Informations complètes</p>
        </div>
      </div>

      {/* Card */}
      <div className="bg-base-100 rounded-xl border border-base-200 shadow-sm">
        {loading ? (
          <div className="py-16 text-center text-base-content/40 text-sm">Chargement…</div>
        ) : !notif ? (
          <div className="py-20 text-center">
            <div className="w-12 h-12 rounded-full bg-base-200 flex items-center justify-center mx-auto mb-3">
              <FaBell className="w-5 h-5 text-base-content/30" />
            </div>
            <p className="text-base-content/40 text-sm">Notification introuvable.</p>
          </div>
        ) : (
          <>
            {/* Meta header */}
            <div className="flex items-center gap-3 px-6 py-4 border-b border-base-200">
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-base-content text-sm">
                  {labelMap[notif.type] || notif.type}
                </p>
                <p className="text-xs text-base-content/40 mt-0.5">
                  {new Date(notif.created_at).toLocaleString()}
                </p>
              </div>
              {notif.is_read ? (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-emerald-500/10 text-emerald-500 border border-emerald-500/20">
                  Lu
                </span>
              ) : (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
                  Non lu
                </span>
              )}
            </div>

            {/* Content */}
            <div className="p-6 space-y-3">
              {notif.content && typeof notif.content === "object"
                ? Object.entries(notif.content).map(([key, val]) => (
                    <div key={key} className="flex flex-col gap-0.5">
                      <span className="text-[11px] font-semibold tracking-wider uppercase text-base-content/40">
                        {key}
                      </span>
                      <div className="text-sm">{renderValue(key, val)}</div>
                    </div>
                  ))
                : <p className="text-sm text-base-content/70">{notif.content}</p>
              }
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NotificationDetail;
